// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_m2k","cls2":"Comments-cls2_dxm Comments-cls1_m2k"};